import questsData from "#quests.gen.json" with { type: "json" };
import { isQuestOfferedAt } from "#quest-scope";
import type { Quest } from "#quest-types";

/**
 * Every quest, in the order the quest list shows them: the `@quests/*.mdx` files in order, built
 * into `quests.gen.json` by `_build-quests`.
 */
export const QUESTS: readonly Quest[] = questsData;

/**
 * The introductory quests, in the order they unlock. They are global, so they are offered
 * wherever the learner is, and each asks only for the little Mandarin learned by then.
 */
// oxlint-disable-next-line no-top/no-top-level-side-effects -- A pure filter of the bundled quests.
export const INTRO_QUESTS: readonly Quest[] = QUESTS.filter(
  (quest) => quest.scope.kind === "global",
);

export function findQuest(questId: string): Quest | undefined {
  return QUESTS.find((quest) => quest.id === questId);
}

/** The quests offered where the learner is (see `isQuestOfferedAt`), locked ones included. */
export function getOfferedQuests(currentAdcode: number | null): Quest[] {
  return QUESTS.filter((quest) => isQuestOfferedAt(quest.scope, currentAdcode));
}
